// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R
const IconCalendarNext = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.5 4.16669L13.3333 10L7.5 15.8334"
        stroke="#E7E7E7"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default IconCalendarNext;
